module.exports = __webpack_public_path__ + "assets/img/demoAccess/subjects/11/details-small.png";